import React, { FC } from 'react'

import { IconCompassProps } from './IconCompass.types'
import * as Styled from './styles/IconCompass.style'

import { nonThemeableRules } from '../../ruleSet'

const IconCompass: FC<IconCompassProps> = ({
  size = nonThemeableRules.defaultSize as number as IconCompassProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconCompassProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M80 .15A79.85 79.85 0 1 0 159.85 80 79.94 79.94 0 0 0 80 .15zm0 151.7A71.85 71.85 0 1 1 151.85 80 71.93 71.93 0 0 1 80 151.85z' />
        <path d='M112.32 36.71 77.1 62.06a18.13 18.13 0 0 0-15 15l-25.32 35.19a7.86 7.86 0 0 0 11 11l35.14-25.46a18.13 18.13 0 0 0 14.94-14.94l25.44-35.14a7.87 7.87 0 0 0-11-11zm-68.58 79.57 20.18-28a18.22 18.22 0 0 0 7.8 7.72zM80 90a10.12 10.12 0 1 1 10.12-10.07A10.13 10.13 0 0 1 80 90zm16.1-18.36a18.22 18.22 0 0 0-7.78-7.8l28-20.17zM80 128a4 4 0 0 0-4 4v8a4 4 0 0 0 8 0v-8a4 4 0 0 0-4-4zm0-96a4 4 0 0 0 4-4v-8a4 4 0 0 0-8 0v8a4 4 0 0 0 4 4zm60 44h-8a4 4 0 0 0 0 8h8a4 4 0 0 0 0-8zM28 76h-8a4 4 0 0 0 0 8h8a4 4 0 0 0 0-8z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconCompass
